
import React, { useState } from "react";
import axios from "axios";

const CateringEventForm = ({ onNext }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    eventType: "",
    date: "",
    time: "",
    location: "",
    city:"",
    state:"",
    country:"",
    guests: "",
    foodType: "",
    requests: "",
    vegPlates: "",
    nonVegPlates: "",
    mixedPlates: "",
    budget: "", // Add budget field
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setFormData({ ...formData, [name]: checked ? value : "" });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const token = localStorage.getItem("authToken");
      const userId = localStorage.getItem("userId");

      // Generate a unique enquiryId
      const enquiryId = `enq_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

      const payload = {
        fullName: formData.name,
        email: formData.email,
        phoneNumber: formData.phone,
        eventType: formData.eventType,
        eventDate: formData.date,
        eventTime: formData.time,
        fullAddress: formData.location,
        city: formData.city,
        city: formData.city,
        city: formData.city,
        state: formData.state,
        country: formData.country,
        guestCount: formData.guests,
        vegPlates: formData.vegPlates,
        nonVegPlates: formData.nonVegPlates,
        mixedPlates: formData.mixedPlates,
        additionalRequests: formData.requests,
        budget: formData.budget || 10000, // Use selected budget or default
        status: "PENDING",
        dishId: [1], // Default empty, will be updated in next step
      };

      const enquiryData = {
        enquiryId: enquiryId,
        formData: formData,
        payload: payload,
        timestamp: new Date().toISOString()
      };

      localStorage.setItem('cateringEnquiry', JSON.stringify(enquiryData));
      localStorage.setItem('currentEnquiryId', enquiryId);

      console.log("Enquiry data stored:", enquiryData);

      // Always alert, even if the server returns 500 as data
      alert("✅ Catering Event Submitted Successfully!");

      // Call onNext to navigate to next page
      if (typeof onNext === "function") {
        onNext();
      } else {
        console.error("onNext prop is not a function!");
      }

    } catch (error) {
      let msg = "❌ Submission failed.";
      if (error.response && error.response.data) {
        msg += "\n" + JSON.stringify(error.response.data);
      } else {
        msg += "\n" + error.message;
      }
      alert(msg);
      console.error(error);
    }
  };

  return (
    <div style={styles.container}>
      <form style={styles.form} onSubmit={handleSubmit}>
        {/* Basic Info - Keep all your existing fields */}
        <input
          style={styles.input}
          type="text"
          name="name"
          placeholder="Your Full Name"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          style={styles.input}
          type="email"
          name="email"
          placeholder="Your Email"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <input
          style={styles.input}
          type="tel"
          name="phone"
          placeholder="Your Phone Number"
          value={formData.phone}
          onChange={handleChange}
          required
        />
        <input
          style={styles.input}
          type="text"
          name="eventType"
          placeholder="Wedding, Corporate, Birthday..."
          value={formData.eventType}
          onChange={handleChange}
          required
        />
        <input
          style={styles.input}
          type="date"
          name="date"
          value={formData.date}
          onChange={handleChange}
          required
        />
        <input
          style={styles.input}
          type="time"
          name="time"
          value={formData.time}
          onChange={handleChange}
          required
        />
        <input
          style={styles.input}
          type="text"
          name="location"
          placeholder="Address"
          value={formData.location}
          onChange={handleChange}
          required
        />
        <input
          style={styles.input}
          type="text"
          name="city"
          placeholder="City"
          value={formData.city}
          onChange={handleChange}
          required
        />
        <input
          style={styles.input}
          type="text"
          name="state"
          placeholder="state"
          value={formData.state}
          onChange={handleChange}
          required
        />
        <input
          style={styles.input}
          type="text"
          name="country"
          placeholder="country"
          value={formData.country}
          onChange={handleChange}
          required
        />


        {/* Veg Plates */}
        <input
          style={styles.input}
          type="number"
          name="vegPlates"
          placeholder="Number of Veg Plates"
          value={formData.vegPlates || ""}
          onChange={handleChange}
          min="0"
          required
        />

        {/* Non-Veg Plates */}
        <input
          style={styles.input}
          type="number"
          name="nonVegPlates"
          placeholder="Number of Non-Veg Plates"
          value={formData.nonVegPlates || ""}
          onChange={handleChange}
          min="0"
          required
        />

        {/* Mixed Plates */}
        <input
          style={styles.input}
          type="number"
          name="mixedPlates"
          placeholder="Number of Mixed Plates"
          value={formData.mixedPlates || ""}
          onChange={handleChange}
          min="0"
          required
        />

        {/* Budget Selection */}
        <div style={styles.budgetSection}>
          <label style={styles.budgetLabel}>Select Budget:</label>
          <div style={styles.budgetOptions}>
            {[10000, 20000, 30000].map((amount) => (
              <label key={amount} style={styles.budgetOption}>
                <input
                  type="checkbox"
                  name="budget"
                  value={amount}
                  checked={formData.budget === amount.toString()}
                  onChange={handleChange}
                  style={styles.checkbox}
                />
                <span>₹{amount.toLocaleString()}</span>
              </label>
            ))}
          </div>
        </div>

        <button type="submit" style={styles.button}>
          ✅ Confirm & Next
        </button>
      </form>
    </div>
  );
};

// Add these new styles to your existing styles object
const styles = {
  // ... your existing styles ...

  budgetSection: {
    marginBottom: '15px',
  },
  budgetLabel: {
    display: 'block',
    marginBottom: '10px',
    fontWeight: '600',
    color: '#2c3e50',
  },
  budgetOptions: {
    display: 'flex',
    gap: '15px',
    flexWrap: 'wrap',
  },
  budgetOption: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 15px',
    border: '1px solid #ddd',
    borderRadius: '8px',
    cursor: 'pointer',
    backgroundColor: '#f8f9fa',
    transition: 'all 0.3s',
  },
  checkbox: {
    width: '18px',
    height: '18px',
    accentColor: '#27ae60',
  },
  container: {
    maxWidth: "1017px",
    margin: "0px auto",
    padding: "10px",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    backgroundColor: "#fff",
  },
  heading: {
    textAlign: "center",
    marginBottom: "20px",
    fontSize: "24px",
    color: "#2c3e50",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  input: {
    padding: "12px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    fontSize: "16px",
    width: "100%",
    boxSizing: "border-box",
  },
  button: {
    backgroundColor: "#27ae60",
    color: "white",
    padding: "14px",
    border: "none",
    borderRadius: "8px",
    fontSize: "18px",
    cursor: "pointer",
    transition: "0.3s",
  },
  "@media (max-width: 768px)": {
    container: { padding: "15px" },
    heading: { fontSize: "20px" },
    input: { fontSize: "14px" },
    button: { fontSize: "16px" },
  }

};



export default CateringEventForm;
